<script setup lang="ts">
/* eslint-disable vue/no-v-html */
import ContentContainer from '@/components/layout/ContentContainer.vue';
import ContentColumn from '@/components/layout/ContentColumn.vue';

defineProps<{
  content: string;
}>();
</script>

<template>
  <ContentContainer class="asideContainer">
    <ContentColumn>
      <aside v-html="content" />
    </ContentColumn>
  </ContentContainer>
</template>

<style lang="scss" scoped>
.asideContainer {
  margin-bottom: var(--spacing-m);

  :deep(.content-container) {
    color: var(--colour-burgundy);

    *:last-child {
      margin-bottom: 0;
    }
  }
}

aside {
  background-color: var(--colour-off-white);
  border: 0.1rem solid var(--colour-light-warm-grey);
  border-radius: 0.2rem;
  padding: var(--spacing-m) var(--spacing-ms);

  math {
    color: #000;
  }
}
</style>
